import React from 'react';
import createIcon from './createIcon';

const Google = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" {...props}>
    <title>Google</title>
    <path d="M459.06,297.78C442.78,404.7,363.06,466,259.85,466c-116,0-210-94-210-210s94-210,210-210c56.1,0,105.26,20,141,54.78L340.63,161c-20.41-20.56-48.35-31.53-80.78-31.53-68.27,0-123.62,58.22-123.62,126.46s55.35,124.83,123.62,124.83c57.22,0,100.55-27.66,113.05-83H259.85V213.44H458.54A246.08,246.08,0,0,1,462.14,256,277.16,277.16,0,0,1,459.06,297.78Z" />
  </svg>
);

Google.displayName = 'Google';

export default createIcon(Google);
